import React from 'react'
import { IconProps, getIconSize } from '../types'

export const ChevronRightIcon: React.FC<IconProps> = ({ 
  className,
  onClick,
  style,
  ...props
}) => {
  const { width, height } = getIconSize(props)

  return (
    // eslint-disable-next-line no-restricted-syntax
    <svg
      className={className}
      width={width}
      height={height}
      onClick={onClick}
      style={style}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path 
        fillRule="evenodd" 
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
        clipRule="evenodd" 
      />
    </svg>
  )
}